import apiClient from "./axios";
import { loginClient } from "./axios";
import { useUserRole } from "./RoleContext";

export const getHeaders = () => {
  // const token = localStorage.getItem("token");
  // const sanitizedToken = token?.replace(/^"(.*)"$/, "$1");
  const headers = {
    // Authorization: `Bearer ${sanitizedToken}`,
    "Access-Control-Expose-Headers": "content-disposition", // Expose the content-disposition header
  };
  return headers;
};
export const getHeaders1 = () => {
  // const token = localStorage.getItem("token");
  // const sanitizedToken = token?.replace(/^"(.*)"$/, "$1");
  const headers = {
    // Authorization: `Bearer ${sanitizedToken}`,
    "Access-Control-Expose-Headers": "content-disposition", // Expose the content-disposition header
    "Response-Type": "Blob",
    "Content-type":
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    mode: "no-cors",
  };
  return headers;
};

export const Login = (values: {
  username: string;
  password: string;
}): Promise<any> => {
  return loginClient.post("Account/Login", values);
};

export const Logout = (): Promise<any> => {
  return loginClient.post("Account/Logout");
};

export const GetTokenFromCookie = (): Promise<any> => {
  return loginClient.get("Account/GetTokenFromCookie");
};

//IT Management Application
export const GetDesignationCategories = () => {
  return apiClient.get(`Designation/GetCategories`, {
    headers: getHeaders(),
  });
};

export const GetCategoryDesignationsById = (categoryId: number) => {
  return apiClient.get(
    `Designation/GetCategoryDesignationsById?categoryId=${categoryId}`,
    {
      headers: getHeaders(),
    }
  );
};

export const GetDesignation = () => {
  return apiClient.get(`Designation/GetDesignations`, {
    headers: getHeaders(),
  });
};

export const AddDesignationCategory = (
  categoryName: string,
  designationList: number[]
) => {
  return apiClient.post(
    `Designation/CreateDesignationCategory?categoryName=${categoryName}`,
    designationList,
    {
      headers: getHeaders(),
    }
  );
};

export const AddDeviceType = (deviceName: string) => {
  return apiClient.post(
    `Device/CreateDeviceType?deviceTypeName=${deviceName}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const UpdateDeviceType = (
  deviceTypeId: number,
  deviceTypeName: string
) => {
  return apiClient.patch(
    `Device/UpdateDeviceType?deviceTypeId=${deviceTypeId}&deviceTypeName=${deviceTypeName}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};

export const AddDomain = (domainName: string) => {
  return apiClient.post(`Domain/CreateDomain?domainName=${domainName}`, null, {
    headers: getHeaders(),
  });
};
export const UpdateDomain = (domainId: number, domainName: string) => {
  return apiClient.patch(
    `Domain/UpdateDomain?domainId=${domainId}&domainName=${domainName}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const UpdateDesignationCategory = (
  categoryId: number,
  categoryName: string,
  designationList: number[]
) => {
  return apiClient.patch(
    `Designation/UpdateDesignationCategory?categoryId=${categoryId}&categoryName=${categoryName}`,
    designationList,
    {
      headers: getHeaders(),
    }
  );
};

export const GetSoftwareList = (isOs: boolean) => {
  return apiClient.get(`Software/GetSoftwares?isOS=${isOs}`, {
    headers: getHeaders(),
  });
};

export const GetVersionBySoftwareId = (softwareId: number) => {
  return apiClient.get(
    `Software/GetVersionsBySoftwareId?softwareId=${softwareId}`,
    {
      headers: getHeaders(),
    }
  );
};

export const GetDeviceList = () => {
  return apiClient.get(`Device/GetDeviceType`, {
    headers: getHeaders(),
  });
};
export const GetLicenseColumns = () => {
  return apiClient.get(`LicenseManagement/GetLicenseColumns`, {
    headers: getHeaders(),
  });
};

export const ManageLicenseColumn = (
  data: { softwareId: number; columnOrder: number }[]
) => {
  return apiClient.post(`LicenseManagement/ManageLicenseColumn`, data, {
    headers: getHeaders(),
  });
};
export const GetLicensesList = () => {
  const newData = {
    designationCategoryIds: [],
    search: "",
  };
  return apiClient.post(`LicenseManagement/GetEmployeeAssetLicenses`, newData, {
    headers: getHeaders(),
  });
};

export const GetDomainList = () => {
  return apiClient.get(`Domain/GetDomain`, {
    headers: getHeaders(),
  });
};
export const GetLicenseManagementSoftwares = () => {
  return apiClient.get(`LicenseManagement/GetSoftwares`, {
    headers: getHeaders(),
  });
};

export const GetEmployeeList = () => {
  return apiClient.get(`LicenseManagement/GetEmployees`, {
    headers: getHeaders(),
  });
};
export const GetIPAddress = () => {
  return apiClient.get(`IPManagement/GetIPAddress`, {
    headers: getHeaders(),
  });
};
export const DeleteEmployeeAsset = (employeeAssetId: string) => {
  return apiClient.put(
    `LicenseManagement/DeleteEmployeeLicense?employeeAssetId=${employeeAssetId}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const updateEmployeeLicense = (updatedata: any) => {
  return apiClient.put(`LicenseManagement/updateEmployeeLicense`, updatedata, {
    headers: getHeaders(),
  });
};
export const ExportTotalLicenseReport = () => {
  return apiClient.get(`Reports/ExportTotalLicenseReport`, {
    responseType: "blob",
    headers: getHeaders1(),
    timeout: 60000, // Set the timeout to 60 seconds (adjust as needed)
  });
};
export const GetAppUserRolesList = () => {
  return apiClient.get(`AdminManagement/GetUserAppRole`, {
    headers: getHeaders(),
  });
};
export const ExportManagementReport = () => {
  return apiClient.get(`Reports/ExportLicenseManagementReport`, {
    responseType: "blob",
    headers: getHeaders1(),
  });
};
export const updateServerLicense = (updatedata: any) => {
  return apiClient.put(`Server/UpdateServerLicense`, updatedata, {
    headers: getHeaders(),
  });
};
export const GetEmployeeDesignationCategoryById = (employeeId: string) => {
  return apiClient.get(
    `LicenseManagement/GetDesignationCategoryByEmployee?employeeId=${employeeId}`,
    {
      headers: getHeaders(),
    }
  );
};

export const GetServerLicense = () => {
  return apiClient.get(`Server/GetServerLicenses`, {
    headers: getHeaders(),
  });
};
export const GetUserRoleEmployeeList = () => {
  return apiClient.get(`AdminManagement/GetSystemadmin`, {
    headers: getHeaders(),
  });
};
export const GetSoftwareLicensingDashboard = (selectedCategory: any) => {
  return apiClient.get(
    `LicenseManagement/GetSoftwareLicensingDashboard?designationCategoryId=${selectedCategory}`,
    {
      headers: getHeaders(),
    }
  );
};

export const GetStatusTypes = () => {
  return apiClient.get(`LicenseRequest/GetApprovalStatus`, {
    headers: getHeaders(),
  });
};
export const GetEmailLicensingDashboard = () => {
  return apiClient.get(`EmailLicensing/GetEmailLicensingDashboard`, {
    headers: getHeaders(),
  });
};
export const GetUserRoleList = () => {
  return apiClient.get(`AdminManagement/GetAppRole`, {
    headers: getHeaders(),
  });
};
export const DeleteAppUserRole = (userAppRoleId: number) => {
  return apiClient.delete(
    `AdminManagement/DeleteUserAppROle?userAppRoleId=${userAppRoleId}`,
    {
      headers: getHeaders(),
    }
  );
};

export const GetEmailLicensingGetEmployees = () => {
  return apiClient.get(`EmailLicensing/GetEmployees`, {
    headers: getHeaders(),
  });
};

export const GetEmailLicensingGetEmail = (employeeId: string) => {
  return apiClient.get(
    `EmailLicensing/GetEmployeeEmail?employeeId=${employeeId}`,
    {
      headers: getHeaders(),
    }
  );
};

export const AddEmailLicense = (data: {
  employeeId: string;
  groupId: number[];
  routing: boolean;
  specialEmailIds: string[];
}) => {
  return apiClient.post(`EmailLicensing/InsertEmailLicense`, data, {
    headers: getHeaders(),
  });
};

export const UpdateEmailLicense = (savedData: any) => {
  return apiClient.patch(`EmailLicensing/UpdateEmailLicense`, savedData, {
    headers: getHeaders(),
  });
};

export const UpdateEmployeeAsResigned = (selected: any[]) => {
  return apiClient.patch(`EmailLicensing/UpateEmployeeAsResigned`, selected, {
    headers: getHeaders(),
  });
};

export const GetEmailLicensingGetEmailLicense = (data: {
  groupId: number[];
  domains: number[];
  employeeStatus: number;
  routingStatus: number;
  haveSpecialEmail: number;
}) => {
  return apiClient.post(`EmailLicensing/GetEmailLicense`, data, {
    headers: getHeaders(),
  });
};

export const GetGroupsList = () => {
  return apiClient.get(`Group/GetGroup`, {
    headers: getHeaders(),
  });
};

export const GetSpecialEmailList = () => {
  return apiClient.get(`SpecialEmail/GetSpecialEmails`, {
    headers: getHeaders(),
  });
};

export const GetPendingTasks = (statusType: number) => {
  return apiClient.get(
    `LicenseRequest/GetPendingSoftwareLicenseRequest?statusId=${statusType}`,
    {
      headers: getHeaders(),
    }
  );
};
export const GetPendingEmailTasks = (statusType: number) => {
  return apiClient.get(
    `LicenseRequest/GetPendingEmailLicensingRequest?statusId=${statusType}`,
    {
      headers: getHeaders(),
    }
  );
};
export const GetApprovalList = () => {
  return apiClient.get(
    `LicenseRequest/GetPendingSoftwareLicenseRequestToApprove`,
    {
      headers: getHeaders(),
    }
  );
};
export const GetApprovalListEmail = () => {
  return apiClient.get(
    `LicenseRequest/GetPendingEmailLicenseRequestToApprove`,
    {
      headers: getHeaders(),
    }
  );
};

export const AddGroupsList = (groupName: string, groupEmailId: string) => {
  return apiClient.post(
    `Group/CreateGroup?groupName=${groupName}&groupEmailId=${groupEmailId}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const AddSpecialEmail = (specialEmail: string, description: string) => {
  return apiClient.post(
    `SpecialEmail/CreateSpecialEmail?specialEmail=${specialEmail}&description=${description}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const UpdateGroupList = (saveData: any) => {
  return apiClient.patch("Group/UpdateGroup", saveData, {
    headers: getHeaders(),
  });
};
export const UpdateSpecialEmail = (saveData: any) => {
  return apiClient.patch("SpecialEmail/UpdateSpecialEmail", saveData, {
    headers: getHeaders(),
  });
};
export const DeleteGroupList = (groupsId: number) => {
  return apiClient.delete(`Group/DeleteGroup?groupId=${groupsId}`, {
    headers: getHeaders(),
  });
};
export const DeleteSpecialEmail = (specialEmailId: number) => {
  return apiClient.delete(
    `SpecialEmail/DeleteSpecialEmail?specialEmailId=${specialEmailId}`,
    {
      headers: getHeaders(),
    }
  );
};
export const DeleteDevice = (deviceId: number) => {
  return apiClient.patch(
    `Device/DeleteDeviceType?deviceTypeId=${deviceId}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};

export const DeleteDomain = (domainId: number) => {
  return apiClient.delete(`Domain/DeleteDomain?domainId=${domainId}`, {
    headers: getHeaders(),
  });
};

export const DeleteCategory = (categoryId: number) => {
  return apiClient.delete(
    `Designation/DeleteCategory?categoryId=${categoryId}`,
    {
      headers: getHeaders(),
    }
  );
};
export const DeleteSoftware = (softwareId: number) => {
  return apiClient.delete(`Software/DeleteSoftware?softwareId=${softwareId}`, {
    headers: getHeaders(),
  });
};
export const createSoftware = (saveData: any) => {
  return apiClient.post("Software/CreateSoftware", saveData, {
    headers: getHeaders(),
  });
};

export const ManageUserAppRole = (saveData: any) => {
  return apiClient.post("AdminManagement/ManageUserAppRole", saveData, {
    headers: getHeaders(),
  });
};

export const ApprovalLicense = (
  licenseRequestId: number,
  approvalStatusId: number,
  comments: string
) => {
  return apiClient.post(
    `LicenseRequest/ApproveSoftwareLicense?licenseRequestId=${licenseRequestId}&approvalStatusId=${approvalStatusId}&comments=${comments}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const ApprovalEmailLicense = (
  licenseRequestId: number,
  approvalStatusId: number,
  comments: string
) => {
  return apiClient.post(
    `LicenseRequest/ApproveEmailLicense?licenseRequestId=${licenseRequestId}&approvalStatusId=${approvalStatusId}&comments=${comments}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const AddIpAddress = (ipAddress: string) => {
  return apiClient.post(
    `IPManagement/CreateIpAddress?ipAddress=${ipAddress}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};
export const DeleteIpAddress = (ipAddressId: number) => {
  return apiClient.delete(
    `IPManagement/DeleteIPAddress?ipAddressID=${ipAddressId}`,
    {
      headers: getHeaders(),
    }
  );
};
export const UpdateSoftware = (saveData: any) => {
  return apiClient.patch("Software/UpdateSoftware", saveData, {
    headers: getHeaders(),
  });
};
export const UpdateIPAddress = (ipAddressId: number, ipAddress: string) => {
  return apiClient.patch(
    `IPManagement/UpdateIPAddress?ipAddressId=${ipAddressId}&ipAddress=${ipAddress}`,
    { headers: getHeaders() }
  );
};

export const AddNewVersion = (saveData: any) => {
  return apiClient.post("Software/ManageVersions", saveData, {
    headers: getHeaders(),
  });
};
export const AddEmployeeLicense = (saveData: any) => {
  return apiClient.post("LicenseManagement/AddEmployeeLicense", saveData, {
    headers: getHeaders(),
  });
};
export const AddServerLicense = (saveData: any) => {
  return apiClient.post("Server/AddServerLicenses", saveData, {
    headers: getHeaders(),
  });
};
export const DeleteVersion = (softwareId: number, versionId: number) => {
  return apiClient.delete(
    `Software/DeleteVersion?softwareId=${softwareId}&versionId=${versionId}`,
    {
      headers: getHeaders(),
    }
  );
};

export const DeleteServer = (serverAssetId: number) => {
  return apiClient.put(
    `Server/DeleteServerLicense?serverAssetId=${serverAssetId}`,
    null,
    {
      headers: getHeaders(),
    }
  );
};

export const axiosErrorMessages = (axiosError: any) => {
  let msg: string;

  if (axiosError.response) {
    // The request was made and the server responded with a status code
    const statusCode = axiosError.response.status;
    switch (statusCode) {
      case 400:
        msg = `Bad request. Please check your input.`;
        break;
      case 401:
        // msg = `Sorry, the login credentials provided are incorrect.`;
        msg = `Session Expired!`;
        break;
      case 403:
        msg = `Access forbidden. You don't have permission to access this resource`;
        break;
      case 405:
        msg = `Method not allowed`;
        break;
      case 404:
        msg = axiosError?.response?.data
          ? axiosError?.response?.data?.errors?.Login[0]
            ? `${axiosError?.response?.data?.errors?.Login[0]}`
            : `${axiosError?.response?.data?.message}`
          : `${axiosError?.message}`;
        break;
      // Add more cases for other status codes as needed
      default:
        msg = `Error: ${axiosError.message}`;
      // setError(`Error: ${axiosError.message}`);
    }
  } else if (axiosError.request) {
    // The request was made but no response was received
    msg = `Network error. Please check your internet connection.`;
  } else {
    msg = `Error: ${axiosError.message}`;
    // Something happened in setting up the request
    // setError(`Error: ${axiosError.message}`);
  }

  return msg;
};
